import { observeElement } from '@uvocore-front/utils';
import { isMobile } from '../../../utils';
import Tooltip from '../../UI/Tooltip';


// Tooltip Observer
const featuresSection = document.querySelector('.FeaturesSection');
if (featuresSection && !isMobile()) {
  observeElement({
    element: '.FeaturesSection',
    marginValue: 400,
    callback: () => {
      Tooltip({
        tooltipsSelector: '[data-tooltip]',
        tooltipTextAttribute: 'data-text',
        className: 'Tooltip',
      });
    },
  });
}
